import React from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { AppButton } from '.'

const Container = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 15px rgba(152, 143, 168, 0.45);
  background-color: ${({ theme }) => theme.custom.colors.common.green};
  color: ${({ theme }) => theme.palette.common.white};
  padding: ${({ theme }) => theme.spacing(2)};
`

const Button = styled(AppButton)`
  border: 2px solid ${({ theme }) => theme.palette.common.white};
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.custom.colors.common.green};
  margin-left: ${({ theme }) => theme.spacing(5)};

  &:hover {
    background-color: ${({ theme }) => theme.custom.colors.common.green};
  }
`

export const ReloadNotification: React.FC = () => {
  const reload = () => window.location.reload()
  return (
    <Container>
      <Typography variant="body1">New version is available. Please reload the page.</Typography>
      <Button variant="contained" onClick={reload}>
        Reload
      </Button>
    </Container>
  )
}
